export default "__VITE_ASSET__DLQuvF1G__"